import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import LandingPage from "../pages/LandingPage";
import AboutPage from "../pages/AboutPage";
import Projects from "../pages/Projects";
import SkillsPage from "../pages/SkillsPage";
import ExperiencePage from "../pages/ExperiencePage";
import TestimonialPage from "../pages/TestimonialsPage";
import ContactPage from "../pages/ContactPage";
import BlogsList from "../pages/BlogsList";
import Blog from "../pages/Blog";

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="" element={<LandingPage />}>
      <Route path="portfolio">
        <Route index element={<AboutPage />} />
        <Route path="projects" element={<Projects />} />
        <Route path="skills" element={<SkillsPage />} />
        <Route path="experience" element={<ExperiencePage />} />
        <Route path="testimonials" element={<TestimonialPage />} />
        <Route path="contact" element={<ContactPage />} />
      </Route>
      <Route path="blogs" element={<BlogsList />} />
      <Route path="blogs/:id" element={<Blog />} />
      <Route path="*" element={<AboutPage />} />
    </Route>
  )
);
